module.exports = __webpack_public_path__ + "media/images/icons/en-e49dbde1653d4093b5cccec0fe2f4f53.png";